import React from "react";
import { CssBaseline, ThemeProvider, createTheme } from "@material-ui/core";
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import CompanySignin from "./pages/CompanySignin";
import CompanySignup from "./pages/CompanySignup";
import CompanyForgotPassword from "./pages/CompanyForgotPassword";
import CompanyDashboard from "./pages/admin/CompanyDashboard";
import CompanyNews from "./pages/admin/CompanyNews";
import CompanyJobs from "./pages/admin/CompanyJobs";
import CompanyProfile from "./pages/admin/CompanyProfile";
import { isAuth } from "./actions/auth";

const theme = createTheme({
  palette: {
    primary: {
      main: "rgba(244,151,3,.8)",
      contrastText: "#fff",
    },
    secondary: {
      main: "rgb(20,61,89)",
      contrastText: "#fff",
    },
    background: {
      default: "#f4f5fd",
    },
  },
});

const App = () => {
  return (
    <Router>
      <ThemeProvider theme={theme}>
        <Switch>
          <Route path="/signin" render={() => <Redirect to="/company/signin" />} />
          <Route path="/signup" render={() => <Redirect to="/company/signup" />} />
          <Route path="/company/signin" component={CompanySignin} />
          <Route path="/company/signup" component={CompanySignup} />
          <Route path="/company/forgot-password" component={CompanyForgotPassword} />

          <Route
            exact
            path="/admin/company-dashboard"
            render={(props) => (isAuth() ? <CompanyDashboard {...props} /> : <Redirect to="/company/signin" />)}
          />

          <Route
            exact
            path="/admin/all-company-news"
            render={(props) => (isAuth() ? <CompanyNews {...props} /> : <Redirect to="/company/signin" />)}
          />

          <Route
            exact
            path="/admin/all-jobs"
            render={(props) => (isAuth() ? <CompanyJobs {...props} /> : <Redirect to="/company/signin" />)}
          />

          <Route
            exact
            path="/admin/profile"
            render={(props) => (isAuth() ? <CompanyProfile {...props} /> : <Redirect to="/company/signin" />)}
          />

          <Route
            path="/"
            render={() => (isAuth() ? <Redirect to="/admin/company-dashboard" /> : <Redirect to="/company/signin" />)}
          />
        </Switch>
        <CssBaseline />
      </ThemeProvider>
    </Router>
  );
};

export default App;
